import { Component } from '@angular/core';

@Component({
	selector: 'app-recovery-password-page',
	templateUrl: './recovery-password-page.component.html',
	styleUrls: ['./recovery-password-page.component.scss']
})
export class RecoveryPasswordPageComponent {}
